import { ENABLED_LOCALES, DEFAULT_LOCALE, isTranslationIndexable, localizedPath, parsePath } from "@/lib/i18n/locales";
import { INDEXABLE_SEO } from "@/lib/i18n/indexableSeo";

const ORIGIN = "https://statlign.com";

/** Pathname of the request being rendered (server ALS or browser URL). */
function requestPath(): string {
  if (typeof window !== "undefined") return window.location.pathname || "/";
  const store = (globalThis as { __statlignRequestPathname?: { getStore: () => string | undefined } })
    .__statlignRequestPathname;
  return store?.getStore() || "/";
}

/**
 * Title/description for an indexable translated page, in the request's
 * language, so the first HTML Google receives is already localized.
 */
export function localizedTitle(path: string, english: { title: string; description: string }) {
  const { locale } = parsePath(requestPath());
  const code = locale || DEFAULT_LOCALE;
  const t = code !== DEFAULT_LOCALE ? INDEXABLE_SEO[code]?.[path] : undefined;
  return t ?? english;
}

/** Full hreflang cluster (+ x-default) for paths open in every language. */
export function hreflangLinks(): { rel: string; hrefLang: string; href: string }[] {
  const raw = requestPath();
  const p = parsePath(raw.length > 1 ? raw.replace(/\/+$/, "") : raw).path || "/";
  const cluster = ENABLED_LOCALES.filter((l) => l.code !== DEFAULT_LOCALE && isTranslationIndexable(l.code, p));
  if (!cluster.length) return [];
  const all = ENABLED_LOCALES.filter((l) => l.code === DEFAULT_LOCALE).concat(cluster);
  return [
    ...all.map((l) => ({ rel: "alternate", hrefLang: l.hreflang, href: `${ORIGIN}${localizedPath(l.code, p)}` })),
    { rel: "alternate", hrefLang: "x-default", href: `${ORIGIN}${localizedPath(DEFAULT_LOCALE, p)}` },
  ];
}
